import { Stack } from "@mui/material";
import Body2 from "../typography/body-02";

const FormField = ({ label, htmlFor, children, isFullWidth }) => (
  <Stack
    direction="column"
    sx={{
      width: {
        xs: "100%",
        sm: isFullWidth ? "100%" : "48%",
        md: isFullWidth ? "100%" : "30%",
      },
    }}
  >
    <Body2
      component="label"
      htmlFor={htmlFor}
      text={label}
      fontType="semibold"
    />
    {children}
  </Stack>
);

export default FormField;
